import {
    MapContainer,
    ImageOverlay,
    Circle,
    Popup,
    useMap,
    Marker,
    CircleMarker,
    AttributionControl, LayersControl, TileLayer
} from 'react-leaflet';
import "leaflet/dist/leaflet.css";
import L from 'leaflet';
import {createContext, useEffect, useRef, useState} from "react";
import MapDragHandler from "./MapDragHandler";
import getTeamColor from "./util/color";

import {MapSize, MapNames} from './util/consts';
import Player from './Player';
import {Control} from "leaflet/dist/leaflet-src.esm";
import InfoPanel from "./util/controls";
import CustomControl from "./util/controls";
import {useCollisionAvoidance} from "./util/collisionAvoidance";
import useWebSocket from "react-use-websocket";

// Load your game map image (ensure the file is in the `public` folder or imported correctly)
const imageUrl = "/Blank.png"; // Place `map.png` inside `public/` folder

let centerPlayer = null;
var factor = 256 / 8160

L.CRS.pr = L.extend({}, L.CRS.Simple, {
    projection: L.Projection.LonLat,
    transformation: new L.Transformation(factor, 0, factor, 0),
    // Changing the transformation is the key part, everything else is the same.
    // By specifying a factor, you specify what distance in meters one pixel occupies (as it still is CRS.Simple in all other regards).
    // In this case, I have a tile layer with 256px pieces, so Leaflet thinks it's only 256 meters wide.
    // I know the map is supposed to be 2048x2048 meters, so I specify a factor of 0.125 to multiply in both directions.
    // In the actual project, I compute all that from the gdal2tiles tilemapresources.xml,
    // which gives the necessary information about tilesizes, total bounds and units-per-pixel at different levels.

    scale: function (zoom) {
        return Math.pow(2, zoom);
    },

    zoom: function (scale) {
        return Math.log(scale) / Math.LN2;
    },

    distance: function (latlng1, latlng2) {
        var dx = latlng2.lng - latlng1.lng,
            dy = latlng2.lat - latlng1.lat;

        return Math.sqrt(dx * dx + dy * dy);
    },
    infinite: true
});

const PlayerMarkers = ({
                           url,
                           setURL,
                           setMapSize,
                           mapSize,
                           setCenter,
                           followSetting,
                           setFollowSetting,
                           hostTeams,
                           paused,

                       }) => {
    const [markers, setMarkers] = useState([]);

    const [serverResp, setServerResp] = useState();
    const [centerCoord, setCenterCoord] = useState([0, 0, 0]);

    const {
        sendMessage,
        sendJsonMessage,
        lastMessage,
        lastJsonMessage,
        readyState,
        getWebSocket,
    } = useWebSocket("/ws", {
        onOpen: () => console.log('opened'),
        //Will attempt to reconnect on all close events, such as server shutting down
        shouldReconnect: (closeEvent) => true,
        reconnectAttempts: 1000,
        reconnectDelay: 1000,
        share: true,

    });
    const map = useMap();

    useEffect(() => {
        if (lastJsonMessage !== null) {
            const data = lastJsonMessage;
            setServerResp(data);
            const mapURL = `/maps/${data.map}/{z}/{x}/{y}.png`;
            if (!MapNames[data.map]) {
                return;
            }
            const newMapSize = MapSize[data.map] / 100;
            const newFactor = 256 / newMapSize;
            if (url !== mapURL || newFactor !== factor) {
                const mapSize = MapSize[data.map] / 100;
                factor = 256 / mapSize;
                L.CRS.pr.transformation = new L.Transformation(factor, 0, factor, 0)
                setMapSize(mapSize);
                setURL(mapURL);
                console.log("set map", mapURL, mapSize);
                if (data.players.length > 0) {
                    setTimeout(() =>
                            map.setView([data.players[0].y, data.players[0].x], map.getZoom(), {animate: true})
                        , 100);

                }

            }
            let hostTeamsNew = [];
            data.players.forEach(player => {
                if (player.teamID === data.teamID) {
                    hostTeamsNew.push(player);
                }
                if (player.name === followSetting.playerName && followSetting.following && !paused.current) {
                    setCenter([player.y, player.x]);
                    setCenterCoord([player.y, player.x, player.z])


                }
            });
            hostTeams.current = hostTeamsNew;
            setMarkers(data.players);
        }

    }, [lastJsonMessage]);

    //}, [setMap, setMapSize, setCenter, setServerResp, MapNames, MapSize]);

    const cb = (name, ID) => {
        return () => {
            if (followSetting.following && followSetting.playerID === ID) {
                centerPlayer = null;
                setFollowSetting({
                    following: false,
                    playerID: ID,
                    playerName: name,
                })


            } else {
                setFollowSetting({
                    following: true,
                    playerID: ID,
                    playerName: name,
                })
            }
            console.log(name);
        }
    };


    return (
        markers.map((player) => (
                <Player
                    key={`player-${player.id}`}
                    player={player}
                    mapSize={mapSize}
                    refHeight={centerCoord[2]}
                    teamID={serverResp.teamID}
                    cb={cb(player.name, player.id)}
                />
            )
        )
    )
}

const UpdateMapCenter = ({center, followSetting, pause}) => {
    const map = useMap();
    useEffect(() => {
        if (followSetting.following && !pause.current) {
            map.setView(center, map.getZoom(), {animate: true});
        }
    }, [center, map, followSetting, pause]);
    return null;
};


// eslint-disable-next-line no-unused-vars
const GameMap = () => {
    const [center, setCenter] = useState([0, 0]);
    const [mapSize, setMapSize] = useState(8192);
    const [url, setUrl] = useState("https://pubg.shell.one/maps/blank.png");

    const paused = useRef(false);
    const [followSetting, setFollowSetting] = useState({
        following: false,
        playerID: -1,
        playerName: "",
    });
    const hostTeams = useRef([]);
    return (
        <MapContainer
            center={center} // Start at the center of the map
            zoom={-3} // Start zoomed out (adjust as needed)
            minZoom={-3} // Allows zooming out further
            maxZoom={3} // Allows zooming in further
            // crs={L.CRS.Simple} // Use a simple coordinate reference system
            style={{height: "100vh", width: "100%"}}
            attributionControl={false}
            maxBoundsViscosity={1.0}
            zoomAnimation={true}
            zoomSnap={0.1} // Allow fractional zoom levels for smooth zooming
            zoomDelta={0.1}
            maxBounds={[[0, 0], [mapSize, mapSize]]}
        >

            <ImageOverlay
                url={url}
                bounds={[[0, 0], [mapSize, mapSize]]}
            />

            <PlayerMarkers
                url={url}
                setURL={setUrl}
                setMapSize={setMapSize}
                mapSize={mapSize}
                setCenter={setCenter}
                followSetting={followSetting}
                setFollowSetting={setFollowSetting}
                hostTeams={hostTeams}
                paused={paused}
            />
            <UpdateMapCenter center={center} followSetting={followSetting} pause={paused}/>
            <MapDragHandler followSetting={followSetting} pause={paused}/>
            <CustomControl followSetting={followSetting} setFollowSetting={setFollowSetting} hostTeams={hostTeams}/>

        </MapContainer>
    );
};


const Tile = ({url}) => {
    const pr = L.extend({}, L.CRS.Simple, {
        projection: L.Projection.LonLat,
        transformation: new L.Transformation(factor, 0, factor, 0),
        // Changing the transformation is the key part, everything else is the same.
        // By specifying a factor, you specify what distance in meters one pixel occupies (as it still is CRS.Simple in all other regards).
        // In this case, I have a tile layer with 256px pieces, so Leaflet thinks it's only 256 meters wide.
        // I know the map is supposed to be 2048x2048 meters, so I specify a factor of 0.125 to multiply in both directions.
        // In the actual project, I compute all that from the gdal2tiles tilemapresources.xml,
        // which gives the necessary information about tilesizes, total bounds and units-per-pixel at different levels.

        scale: function (zoom) {
            return Math.pow(2, zoom);
        },

        zoom: function (scale) {
            return Math.log(scale) / Math.LN2;
        },

        distance: function (latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng,
                dy = latlng2.lat - latlng1.lat;

            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });

    return (<TileLayer
            url={url}
            crs={pr} // Keeps it in a simple coordinate system
            minNativeZoom={2}
            maxNativeZoom={7}
            tileSize={256}
            continuousWorld={false}
            noWrap={true} // Prevents map from repeating
            // bounds={mapBounds}
        />
    )
}
const NewGameMap = () => {
    const mapBounds = [
        [0, 0],      // Top-left corner (y-axis is inverted in Leaflet)
        [2040, 2040] // Bottom-right corner
    ];

    const [url, setUrl] = useState("/maps/Baltic_Main/{z}/{x}/{y}.png");

    const hostTeams = useRef([]);
    const [center, setCenter] = useState([4096, 4096]);
    const [mapSize, setMapSize] = useState(8190);


    const paused = useRef(false);
    const [followSetting, setFollowSetting] = useState({
        following: false,
        playerID: -1,
        playerName: "",
    });
    const tileLayerRef = useRef(null);
    useEffect(() => {
        if (tileLayerRef.current) {
            tileLayerRef.current.setUrl(url);
            tileLayerRef.current.redraw();
        }
    }, [url])
    return (
        <MapContainer
            zoom={2}
            center={center} // Center at the middle of the map
            minZoom={2}
            maxZoom={7}
            crs={L.CRS.pr} // Keeps it in a simple coordinate system
            style={{height: "100vh", width: "100%"}}
            maxBoundsViscosity={1.0} // Makes panning outside smooth
            attributionControl={false}
            // maxBounds={mapBounds}
        >
            <TileLayer
                url={url}
                ref={tileLayerRef}
                crs={L.CRS.cr} // Keeps it in a simple coordinate system
                minNativeZoom={2}
                maxNativeZoom={7}
                zoom={2}
                tileSize={256}
                continuousWorld={false}
                noWrap={true} // Prevents map from repeating
                // bounds={mapBounds}
            />
            {/*<Tile url={url}/>*/}
            <PlayerMarkers
                url={url}
                setURL={setUrl}
                setMapSize={setMapSize}
                mapSize={mapSize}
                setCenter={setCenter}
                followSetting={followSetting}
                setFollowSetting={setFollowSetting}
                hostTeams={hostTeams}
                paused={paused}

            />
            <UpdateMapCenter center={center} followSetting={followSetting} pause={paused}/>
            <MapDragHandler followSetting={followSetting} pause={paused}/>
            <CustomControl followSetting={followSetting} setFollowSetting={setFollowSetting} hostTeams={hostTeams}/>
        </MapContainer>
    );
};

export default NewGameMap;
